<template>
  <b-modal id="modal-video-conf" class="modal"  size="xl" hide-footer>
            <template v-slot:modal-header="{ close }">
      <h5 class="modal-title" id="exampleModalLabel">
        <a @click="$bvModal.hide('modal-video-conf')" class="prevButton backArrow mr-2" data-dismiss="modal">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160
              c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
              c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z
              "
                />
              </g>
            </g>
          </svg>
        </a> Schedule a Video Conference
      </h5>
      <button @click="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
  <div class="" :style="`background: url('${patternBg}') repeat #f5f5f5;height: 100%;padding: 30px;`">
          <div class="row">

            <div class="col-md-5">
              <img src="@/assets/images/conference.png" class="img-fluid " style="    opacity: .8;
              padding: 3rem!important;">
            </div>
            <div class="col-md-7 p-3">
              <div class="side-menu form-side">
                <form @submit.prevent="createLead" class="enqForm">
                  <h4 class="pb-2">Personal Information</h4>

                  <div class="row">
                    <div class="col-md-6 form-group">
                      <label for="">Name*</label>
                      <input type="text" class="form-control" placeholder="Name" v-model="lead.custName" required="true">
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="">Phone*</label>
                      <input type="text" class="form-control" minlength="10" placeholder="Phone" v-model="lead.custPhone"  required="true">
                    </div>
                    <div class="col-md-6 form-group">
                      <label for="">Email</label>
                      <input type="email" class="form-control" placeholder="Email" v-model="lead.custEmail">
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="">Preferred Date*</label>
                      <date-picker
                        v-model="lead.custDate"
                        input-class="form-control"
                        placeholder="Preferred Date "
                        :clear-button="true"
                        :required="true"
                      ></date-picker>
                    </div>
                    <div class="col-md-3 form-group">
                      <label for="">Preferred Time*</label>
                      <select class="custom-select" v-model="lead.custTime" required="true">
                        <option v-for="time in selectableTimes" :value="time">{{time}}</option>
                      </select>
                    </div>
                    <div class="col-md-12 form-group mt-2 mb-0">
                      <button type="submit" class="btn btn-primary">Schedule now</button>
                    </div>
                  </div>

                </form>
              </div>
            </div>

          </div>

        </div>
  </b-modal>
</template>
<script>
import {selectableTimes, confCallParams, scheduleConfUrl} from '@/assets/scripts/utility.js'
import patternBg from '@/assets/images/pattern.png'
export default {
  data(){
    return {
      lead: {},
      patternBg
    }
  },
  computed: {
    selectableTimes(){
      return selectableTimes;
    }
  },
  methods: {
    createLead(){
      let lParams = confCallParams(this.lead)
      this.$axios.post(scheduleConfUrl, lParams)
        .then(res => {
          let crmLeadNo = res.data.data
          localStorage.setItem('crmleadNo', crmLeadNo)
          this.lead = {}
          swal({
            title: "You will be contacted shortly!",
            icon: "success"
          });
        })
        .catch(err => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error"
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error"
            });
          }
        })
    }
  }
}
</script>